import {Page404} from '@mintdata-wsp/wsp/ui/pages/common/Page404';
import {SampleDesignPage} from '@mintdata-wsp/wsp/ui/pages/visualDesigner/SampleDesignPage';
import {ForgotPasswordPage} from '@mintdata-wsp/wsp/ui/pages/workspace/ForgotPasswordPage';
import {JoinOrganizationPage} from '@mintdata-wsp/wsp/ui/pages/workspace/JoinOrganizationPage';
import {JoinPage} from '@mintdata-wsp/wsp/ui/pages/workspace/JoinPage';
import {LoggedInPages} from '@mintdata-wsp/wsp/ui/pages/workspace/LoggedInPages';
import {LoginPage} from '@mintdata-wsp/wsp/ui/pages/workspace/LoginPage';
import {NewPasswordPage} from '@mintdata-wsp/wsp/ui/pages/workspace/NewPasswordPage';
import {SignUpPage} from '@mintdata-wsp/wsp/ui/pages/workspace/SignUpPage';
import {UnsupportedPage} from '@mintdata-wsp/wsp/ui/pages/workspace/UnsupportedPage';
import {AuthRoute} from '@mintdata-wsp/wsp/ui/routes/AuthRoute';
import {LinkUtil} from '@mintdata-wsp/wsp/ui/routes/LinkUtil';
import {PublicRoute} from '@mintdata-wsp/wsp/ui/routes/PublicRoute';
import {RedirectIfLoggedInRoute} from '@mintdata-wsp/wsp/ui/routes/RedirectIfLoggedInRoute';
import * as React from 'react';

export class Paths
{
    private _root   = '';

    login            = () => `${this._root}/login`;
    unsupported      = () => `${this._root}/unsupported`;
    signup           = () => `${this._root}/sign-up`;
    join             = () => `${this._root}/join/:inviteCode`;
    joinOrganization = () => `${this._root}/join-organization/:inviteCode`;
    forgotPassword   = () => `${this._root}/forgot-password`;
    newPassword      = () => `${this._root}/new-password/:token`;

    index            = ()                                                => `${this._root}/`;
    search           = ()                                                => `${this._root}/search`;
    designs          = ()                                                => `${this._root}/designs`;
    applications     = ()                                                => `${this._root}/applications`;
    templates        = ()                                                => `${this._root}/templates`;
    template         = (templateName?:string)                            => `${this._root}/templates/${templateName}`;
    spaces           = (projectId:any)                                   => `${this._root}/spaces/${projectId}`;
    settings         = ()                                                => `${this._root}/settings`;

    // project         = (projectId:any)                                   => `${this._root}/${projectId}`;
    sampleDesign     = (designId:any)                                    => `${this._root}/sample-design/${designId}`;
    universeDesign   = (designId:any)                                    => `${this._root}/universe-design/${designId}`;
    takeScreenshot  = (projectId:any, designId:any)                     => `${this._root}/take-screenshot/${projectId}/${designId}`;

    design = (projectId:any, designId:any, isMp:boolean = true) => {
        return `${this._root}/${projectId}/${designId}` + (isMp ? '' : '#multiplayer=no');
    };
    flowEditor = (projectId:any, designId:any, functionId:any, isMp:boolean = true)  => {
        return `${this._root}/${projectId}/${designId}/flow/${functionId}` + (isMp ? '' : '#multiplayer=no');
    };
    // publishedApps   = ()                                                => `${this._root}/published-apps`;
    codeEditorBody  = ()                                                => `${this._root}/assets/vendor/monaco-editor/monaco-editor.html`;
}

const Path = new Paths();

export class Routes
{
    // ---------------------------------------
    // Public :: 404
    page404         = () => <PublicRoute                                                                        page={Page404}/>;

    // ---------------------------------------
    // Public
    login           = () => <RedirectIfLoggedInRoute exact path={`${Path.login()}`}                             page={LoginPage}/>;
    unsupported     = () => <PublicRoute exact path={`${Path.unsupported()}`}                                   page={UnsupportedPage}/>;
    signup          = () => <RedirectIfLoggedInRoute exact path={`${Path.signup()}`}                            page={SignUpPage}/>;
    join            = () => <PublicRoute exact path={`${Path.join()}`}                                          page={JoinPage}/>;
    joinOrganization= () => <PublicRoute exact path={`${Path.joinOrganization()}`}                              page={JoinOrganizationPage}/>;
    sampleDesign    = () => <PublicRoute path={`${Path.sampleDesign(':designId')}`}                             page={SampleDesignPage}/>;
    universeDesign  = () => <PublicRoute path={`${Path.universeDesign(':designId')}`}                           page={SampleDesignPage}/>;
    takeScreenshot  = () => <PublicRoute path={`${Path.takeScreenshot(':projectId', ':designId')}`}             page={SampleDesignPage}/>;
    forgotPassword  = () => <RedirectIfLoggedInRoute exact path={`${Path.forgotPassword()}`}                    page={ForgotPasswordPage}/>;
    newPassword     = () => <RedirectIfLoggedInRoute exact path={`${Path.newPassword()}`}                       page={NewPasswordPage}/>;

    // ---------------------------------------
    // TODO: -> moved to LoggedInPages.tsx
    // Authenticated
    // index           = () => <AuthRoute exact path={`${Path.index()}`}                                           page={MainPage}/>;
    // settings        = () => <AuthRoute path={`${Path.settings()}`}                                              page={OrganizationSettingsPage}/>;
    // publishedApps   = () => <AuthRoute path={`${Path.publishedApps()}`}                                         page={PublishedAppsPage}/>;
    // flowEditor      = () => <AuthRoute path={`${Path.flowEditor(':projectId', ':designId', ':functionId')}`}    page={FlowEditorPage} />;
    // design          = () => <AuthRoute path={`${Path.design(':projectId', ':designId')}`}                       page={EditDesignPage}/>;
    // project         = () => <AuthRoute path={`${Path.project(':projectId')}`}                                   page={MainPage}/>;

    // ---------------------------------------
    // WSP pages
    wspPages        = () => <AuthRoute path={'*'} page={LoggedInPages}/>;
}

export class LinkFactory
{
    toLogin             = (caption:string, className?:string)   => LinkUtil.make('login', caption, className);
    toSignUp            = (caption:string, className?:string)   => LinkUtil.make('signup', caption, className);
    toForgotPassword    = (caption:string, className?:string)   => LinkUtil.make('forgotPassword', caption, className);
}
